// extracted by mini-css-extract-plugin
export default {"Button":"DeleteButton_Button__0B5UA"};